import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx, _cache) {
  const _component_Img = _resolveComponent("Img")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('form-header__inner'))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createCommentVNode(" Render Form Header Text "),
        (component.type=='header_text')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.getClass('header__text'))
            }, [
              _createElementVNode("p", {
                innerHTML: _ctx.decodeTags(component.label),
                style: _normalizeStyle(_ctx.computedFontStyle)
              }, null, 12 /* STYLE, PROPS */, _hoisted_1)
            ], 2 /* CLASS */))
          : (component.type=='header_image')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" Render Form Header Image "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('header__image'))
                }, [
                  _createVNode(_component_Img, { component: component }, null, 8 /* PROPS */, ["component"])
                ], 2 /* CLASS */)
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}